class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.allowOpenUntil = 0;
    this.desktopQuery = window.matchMedia('(min-width: 992px)');

    this.summary.addEventListener('pointerdown', this.allowUserOpen.bind(this));
    this.summary.addEventListener('keydown', (event) => {
      if (event.code === 'Enter' || event.code === 'Space') this.allowUserOpen();
    });
    this.closeOnScroll = this.closeOnScroll.bind(this);
    window.addEventListener('scroll', this.closeOnScroll, { passive: true });
    window.addEventListener('wheel', this.closeOnScroll, { passive: true, capture: true });
    window.addEventListener('touchmove', this.closeOnScroll, { passive: true, capture: true });
  }

  allowUserOpen() {
    this.allowOpenUntil = Date.now() + 700;
    this.mainDetailsToggle.classList.add('is-user-open');
  }

  onToggle() {
    if (!this.header) return;

    if (this.mainDetailsToggle.open && Date.now() > this.allowOpenUntil) {
      this.close();
      return;
    }

    if (!this.mainDetailsToggle.open) {
      this.mainDetailsToggle.classList.remove('is-user-open');
    }

    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    super.close();
    this.mainDetailsToggle.classList.remove('is-user-open');
  }

  closeOnScroll() {
    if (!this.mainDetailsToggle.open) return;
    this.close();
  }
}

customElements.define('header-menu', HeaderMenu);
